// HELPERS
import AttachFiles from "../AttachFiles";

/**
 * Version of AttachFiles that is visible for companies only
 */
export default class AttachFilesCompany extends AttachFiles {
	static companyExclusive = true;
	static privateExclusive = false;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/AttachFiles/AttachFilesCompany/AttachFilesCompany.js